
import "wix-ui-tpa/index.st.css";
import "wix-ui-tpa/index.st.css";
export var namespace = /* INJECT */ {__namespace__:true};
export var classes = /* INJECT */ {__classes__:true};
export var keyframes = /* INJECT */ {__keyframes__:true}; 
export var stVars = /* INJECT */ {__stVars__:true}; 
export var vars = /* INJECT */ {__vars__:true}; 
export var cssStates = /* INJECT */ {__stc__:true};
export var style = /* INJECT */ {__sts__:true};
export var st = /* INJECT */ {__st__:true};
/* JS_INJECT */
if(import.meta.webpackHot /* HMR */) { import.meta.webpackHot.accept();}
